import React, { useEffect } from 'react';

import { LoadingType, setLoadingState } from 'prequalificationV2/actions';
import { CompleteAuthenticationRequest } from 'api/ProveApi';
import Loader from 'components/Loader';
import { useAppDispatch } from 'prequalificationV2/hooks/useAppDispatch';
import { useAppSelector } from 'prequalificationV2/hooks/useAppSelector';

const RedirectToProveLink = (vfp: CompleteAuthenticationRequest) => {
  const dispatch = useAppDispatch();

  const loading = useAppSelector((state) => state.loading[LoadingType.GetData]);

  useEffect(() => {
    dispatch(setLoadingState({ type: LoadingType.GetData, loading: true }));
    window.location.href = process.env.REACT_APP_PROVE_AUTHENTICATION_LINK + vfp.vfp;
  }, [dispatch, vfp.vfp]);

  return <>{loading ? <Loader /> : <></>}</>;
};

export default RedirectToProveLink;
